import { useMutation as e } from "@maat/store-hooks";
import { notificationsApi as t } from "@maat/api-notifications";
//#region src/notifications/useRemovePushTokenMutation.ts
var n = () => e({ mutationFn: (e) => t.removePushToken(e) });
//#endregion
export { n as useRemovePushTokenMutation };
